import { formattedTypeContainer } from "../../components/formatted/FormattedText";

function capitalizeWord(value) {
  const text = String(value || "").trim();
  if (!text) {
    return "";
  }
  return text.charAt(0).toUpperCase() + text.slice(1);
}

function normalizeContainerObjectId(id) {
  if (id == null) {
    return "";
  }
  if (typeof id === "string") {
    return id;
  }
  if (typeof id === "object" && id._id != null) {
    return String(id._id);
  }
  return String(id);
}

export function normalizeContainerObjectIdList(list) {
  return (list || []).map(normalizeContainerObjectId).filter(Boolean);
}

export function filterContainersForSite(containersList, addressId) {
  if (!Array.isArray(containersList)) {
    return [];
  }
  if (!addressId) {
    return [];
  }
  const siteAddressId = String(addressId);
  return containersList.filter(
    (container) => String(container.addressId) === siteAddressId,
  );
}

export function formatContainerMonitoringLabel(container) {
  const categoryLabel = container.contentCategory?.[0]?.label ?? "";
  const positioning = capitalizeWord(container.positioning) || "?";
  return `${formattedTypeContainer(container.type)} - ${container.volume}${container.volumeUnit} - ${categoryLabel} - ${positioning}`;
}

export function isContainerSelected(selectedIds, containerId) {
  const normalizedId = normalizeContainerObjectId(containerId);
  return selectedIds.includes(normalizedId);
}

export function areContainerIdListsEqual(listA, listB) {
  const left = [...normalizeContainerObjectIdList(listA)].sort();
  const right = [...normalizeContainerObjectIdList(listB)].sort();
  return (
    left.length === right.length &&
    left.every((id, index) => id === right[index])
  );
}

export function formatContainersPickerSubtitle(
  t,
  { addressId, loading, selectedCount, totalCount },
) {
  if (!addressId) {
    return t("installation_side_containers_no_site");
  }
  if (loading) {
    return t("installation_loading");
  }
  if (totalCount === 0) {
    return t("installation_side_containers_empty");
  }
  if (selectedCount === 0) {
    return t("installation_side_containers_subtitle_none");
  }
  return t("installation_side_containers_subtitle_count", {
    count: selectedCount,
  });
}

export function toggleContainerSelection(selectedIds, containerId) {
  const normalizedId = normalizeContainerObjectId(containerId);
  if (!normalizedId) {
    return selectedIds;
  }
  if (selectedIds.includes(normalizedId)) {
    return selectedIds.filter((id) => id !== normalizedId);
  }
  return [...selectedIds, normalizedId];
}
